/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProjectManagement = lazyLoad(
  () => import('./index'),
  module => {
    return module.ProjectManagement;
  },
);
